import { Badge } from 'react-bootstrap';
import styles from './Pill.module.scss';
import cn from 'classnames';
import PropTypes from 'prop-types';

export function Pill(props) {
  const { title, value } = props;

  const showSeparator = !!(title && value);

  return (
    <Badge pill={true} className={styles.badgeWrapper}>
      {title && (
        <label>
          {title}
          {showSeparator && ': '}
        </label>
      )}
      {value && <span>{value}</span>}
      {props.onRemove && (
        <button type="button" className={cn(styles.removeButton, 'ic-close')} onClick={() => props.onRemove()} />
      )}
    </Badge>
  );
}

Pill.propTypes = {
  title: PropTypes.string,
  value: PropTypes.string.isRequired,
  onRemove: PropTypes.func,
};
